export const REQUEST_PRINT = 'REQUEST_PRINT';
export const RECEIVE_PRINT = 'RECEIVE_PRINT';
export const ADD_TO_PRINTQUEUE = 'ADD_TO_PRINTQUEUE';
export const REMOVE_FROM_PRINTQUEUE = 'REMOVE_FROM_PRINTQUEUE';
export const CLEAR_PRINTQUEUE = 'CLEAR_PRINTQUEUE';

import {apiRoutes, post} from '../../api/api';


function requestPrint(selection) {
  return {
    type: REQUEST_PRINT,
    selection
  };
}

function receivePrint(selection, data) {
  return {
    type: RECEIVE_PRINT,
    response: data,
    selection,
    receivedAt: Date.now()
  };
}

export function fetchPrint(selection) {
  return dispatch => {
    dispatch(requestPrint(selection));
    const url = apiRoutes.batch.getEmpty();
    let selectionIds = selection.split('=')[1].split(',');
    return post(url, {selection: selectionIds}, function (response) {
      dispatch(receivePrint(selection, response));
    });
  };
}

let printSelectionId = 0;
export function addToPrintQueue(language, selection, label = null) {
  return {
    type: ADD_TO_PRINTQUEUE,
    item: {
      id: printSelectionId++,
      language: language,
      selection: selection,
      label
    }
  };
}

export function removeFromPrintQueue(id) {
  return {
    type: REMOVE_FROM_PRINTQUEUE,
    id: id
  };
}

export function clearPrintQueue(id) {
  return {
    type: CLEAR_PRINTQUEUE,
    id: id
  };
}



/** WEBPACK FOOTER **
 ** ./src/modules/print/actions.js
 **/